import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Change the position of the coil to see the effect on the Bℓ factor. Repeat for all three types of coils.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0426/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
